/**
 * Form helper utilities for ChatsPage components
 */

/**
 * Converts an array of email strings to a comma-separated string
 */
export const formatEmailsToString = (
  emails: string[] | null | undefined
): string => {
  if (!emails || emails.length === 0) return '';
  return emails.join(', ');
};

/**
 * Converts a comma-separated string of emails to an array
 */
export const parseEmailsFromString = (emailString: string): string[] => {
  if (!emailString.trim()) return [];
  return emailString
    .split(',')
    .map((email) => email.trim())
    .filter((email) => email.length > 0);
};

/**
 * Validates email form state for the RemoveEmailModal
 */
export const validateEmailForm = (
  loading: boolean,
  errors: any,
  isDirty: boolean,
  email: string
): boolean => {
  return loading || !!errors.additionalEmail || !isDirty || !email?.trim();
};

/**
 * Gets button label based on loading state
 */
export const getButtonLabel = (
  loading: boolean,
  defaultLabel: string
): string => {
  return loading ? 'Processing...' : defaultLabel;
};
